export const MAX_AUDIO_UPLOAD_BYTES = 25 * 1024 * 1024;
export const MAX_AUDIO_UPLOAD_DURATION_SECONDS = 5 * 60;

export const SUPPORTED_AUDIO_UPLOAD_EXTENSIONS = [
  ".ogg",
  ".webm",
  ".mp3",
  ".wav",
  ".m4a",
  ".flac",
  ".aac",
] as const;

export const SUPPORTED_AUDIO_UPLOAD_ACCEPT =
  SUPPORTED_AUDIO_UPLOAD_EXTENSIONS.join(",");

export const SUPPORTED_AUDIO_UPLOAD_DISPLAY =
  SUPPORTED_AUDIO_UPLOAD_EXTENSIONS.join(", ");

export function formatAudioDurationLimit(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
}

export function isSupportedAudioUploadFile(file: File): boolean {
  const lowerName = file.name.toLowerCase();
  return SUPPORTED_AUDIO_UPLOAD_EXTENSIONS.some((extension) =>
    lowerName.endsWith(extension),
  );
}

export function validateAudioUploadFile(file: File): string | null {
  if (!isSupportedAudioUploadFile(file)) {
    return `Unsupported audio file type. Use one of: ${SUPPORTED_AUDIO_UPLOAD_DISPLAY}.`;
  }

  if (file.size > MAX_AUDIO_UPLOAD_BYTES) {
    return `File size must be ${Math.round(
      MAX_AUDIO_UPLOAD_BYTES / (1024 * 1024),
    )}MB or less.`;
  }

  return null;
}
